const $ = jQuery.noConflict();

$(document).ready(function () {

  const splide = new Splide('#athletics-slider', {
    arrows: false,
    easing: 'ease',
    fixedWidth: false,
    gap: 24,
    pagination: false,
    perPage: 4,
    rewind: true,
    slideFocus: false,
    breakpoints: {
      414: {
        fixedWidth: false,
        pagination: true,
        perPage: 1,
      },
      768: {
        fixedWidth: 276,
        pagination: true,
        perPage: 1,
      },
      1279: {
        fixedWidth: 276,
        pagination: true,
        perPage: 3,
      },
    },
  }).mount();

  $('#athleticsDropdown').change(function () {
    const slug = $(this).val();

    $.fn.imagesLoaded = function () {

      // get all the images (excluding those with no src attribute)
      const $imgs = this.find('img[src!=""]');
      // if there's no images, just return an already resolved promise
      if (!$imgs.length) {return $.Deferred().resolve().promise();}

      // for each image, add a deferred object to the array which resolves when the image is loaded (or if loading fails)
      const dfds = [];
      $imgs.each(function (){

        const dfd = $.Deferred();
        dfds.push(dfd);
        const img = new Image();
        img.onload = function (){dfd.resolve();};
        img.onerror = function (){dfd.resolve();};
        img.src = this.src;
      });

      // return a master promise object which will resolve when all the deferred objects have resolved
      // IE - when all the images are loaded
      return $.when.apply($, dfds);
    };

    $.ajax ({
      url: '/api/athletics/' + slug,
      dataType: 'json',
      beforeSend: function () {
        $('.athletics-loading').show();
        $('#athletics__story .story__featured__tier1').hide();
        $('#athletics__story .story__featured__tier2').hide();
      },
      success: function (data) {
        $('#athletics__story .story__featured__tier1').html('<article class="story__featured-card"><a class="img-link" href="' + data.athletics[0].link + '" tabindex="-1"><img class="story__featured-image" src="' + data.athletics[0].image_full + '" alt="' + data.athletics[0].image_alt_text + '"></a><div class="story__featured-content"><p class="story__featured-date">' + data.athletics[0].publishDate +'</p><h3 class="story__featured-title"><a class="link" href="' + data.athletics[0].link + '">' + data.athletics[0].title + '</a></h3><p class="story__featured-blurb">' + data.athletics[0].description + '</p></div></article>');

        $('#athletics-slider .splide__list li').remove();

        for (let i = 1; i < 4; i++) {
          if (data.athletics[i].title.length > 40) {
            data.athletics[i].title = data.athletics[i].title.substring(0, 40) + '&hellip;';
          }

          $('#athletics-slider .splide__list').append('<li class="splide__slide"><article class="story__secondary-card"><a class="story__secondary-card-link" href="' + data.athletics[i].link + '"><div class="story__secondary-card-container"><img class="story__secondary-card-image" src="' + data.athletics[i].image_full + '" alt="' + data.athletics[i].image_full + '" /> </div><p class="story__secondary-card-title"><span>' + data.athletics[i].title + '</span></p></a></article></li>');
        }

        if (data.athletics['game'].length !== 0) {
          $('#athletics-slider .splide__list').append('<li class="splide__slide"><article class="story__secondary-card game-event"><a class="story__secondary-card-link" href="' + data.athletics['game'].link + '"><div class="story__secondary-card-container"><h3 class="story__secondary-card-title">Next Game</h3><div class="event-info"><span>UCLA</span> vs. <span>' + data.athletics['game'].opponent + '</span></div><div class="event-location">Time: ' + data.athletics['game'].startdate + ' Location: ' + data.athletics['game'].location + '</div></div><div class="tickets-container">Full Calendar</div></a></article></li>');
        }
        else {
          if (data.athletics[4].title.length > 40) {
            data.athletics[4].title = data.athletics[4].title.substring(0, 40) + '&hellip;';
          }
          $('#athletics-slider .splide__list').append('<li class="splide__slide"><article class="story__secondary-card"><a class="story__secondary-card-link" href="' + data.athletics[4].link + '"><div class="story__secondary-card-container"><img class="story__secondary-card-image" src="' + data.athletics[4].image_full + '" alt="' + data.athletics[4].image_full + '" /> </div><p class="story__secondary-card-title"><span>' + data.athletics[4].title + '</span></p></a></article></li>');
        }

        $('#athletics__story').imagesLoaded().then(function () {
          $('.athletics-loading').hide();
          $('#athletics__story .story__featured__tier1').show();
          $('#athletics__story .story__featured__tier2').show();
          splide.refresh();
        });
      }
    });
  });
});
